import { tokens as e } from "./tokens/index.js";
import { breakpoints as o } from "./breakpoints.js";
var t = {
  tokens: e,
  breakpoints: o,
  name: "default-theme"
};
export { t as defaultTheme };